import { Controller } from "@hotwired/stimulus"

// お知らせルールフォームで「単発/繰り返し」切り替え時にフィールドの表示/非表示を制御
export default class extends Controller {
  static targets = ["oneOffFields", "recurringFields"]

  static FIELD_SELECTOR = "input, select, textarea, button, wa-input, wa-select, wa-textarea, wa-radio-group, wa-checkbox"

  connect() {
    const selected = this.element.querySelector("wa-radio-group wa-radio[checked], input[type='radio']:checked")
    const value = selected?.getAttribute("value") ?? selected?.value
    this.applyToggle(value === "recurring")
  }

  toggle(event) {
    const value = event.detail?.value ?? event.target.value
    this.applyToggle(value === "recurring")
  }

  applyToggle(isRecurring) {
    this.oneOffFieldsTargets.forEach((el) => {
      el.hidden = isRecurring
      el.querySelectorAll(this.constructor.FIELD_SELECTOR).forEach((f) => { f.disabled = isRecurring })
    })

    this.recurringFieldsTargets.forEach((el) => {
      el.hidden = !isRecurring
      el.querySelectorAll(this.constructor.FIELD_SELECTOR).forEach((f) => { f.disabled = !isRecurring })
    })
  }
}
